import '../assets/styles/App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import { getCookie, setCookie } from '../cookie/cookies';
import SwipeableViews from 'react-swipeable-views';

function ShareEmotion({}) {
    // get device width
    const [searchParams, setSearchParams] = useSearchParams();
    const [width, setWidth] = useState(window.innerWidth);

    const [vialMaskSize, setvialMaskSize] = useState(
        width > 578 ? 150 : (width * 91) / 375
    );

    const [cardMaskSize, setCardMaskSize] = useState(
        width > 578 ? 255 : (width * 255) / 375
    );

    const [vialInfo, setvialInfo] = useState({
        customData: '',
        description: '',
        extractTime: '',
        images: [],
        label: '',
        videoUrl: '',
        vialImage: '',
    });

    const emotionId = searchParams.get('emotionId');

    useEffect(() => {
        const getvialInfo = async () => {
            const url = `${process.env.REACT_APP_API_URL}/getEmotionForShare`;
            const data = {
                emotionId: emotionId,
            };

            axios
                .post(url, data)
                .then((res) => {
                    if (res.data) {
                        let tmpType = res.data.emotionType.N;
                        let ticket = '';
                        let type = '';
                        let imageArray = [];
                        let videoUrl = '';
                        if (tmpType === '1' || tmpType === '2') {
                            if (tmpType === '1') {
                                type = 'Photo';
                                if (res.data.images.S !== '{}') {
                                    imageArray = JSON.parse(
                                        res.data.images.S
                                    ).images;
                                } else {
                                    imageArray = [];
                                }
                            } else if (tmpType === '2') {
                                type = 'Video';
                            }
                            ticket = 'Random Diversity : The Movie';
                        } else if (tmpType === '3') {
                            type = 'ID Card';
                            if (res.data.images.S !== '{}') {
                                imageArray = JSON.parse(
                                    res.data.images.S
                                ).images;
                            } else {
                                imageArray = [];
                            }
                            ticket = 'Random Destiny';
                        }

                        // split custom data by ,
                        let tmpCustomData = res.data.customData.S.split(',');
                        let tmpData = {
                            customData: tmpCustomData,
                            emotionType: type,
                            ticket: ticket,
                            time: res.data.extractTime.S,
                            label: res.data.label.S,
                            vialImage: res.data.vialImage.S,
                            images: imageArray,
                            description: res.data.description.S,
                            videoUrl: videoUrl,
                        };
                        setvialInfo(tmpData);
                    }
                })
                .catch((error) => console.log(error));
        };

        getvialInfo();
    }, [emotionId]);

    let navigate = useNavigate();

    const routeChange = (isInternal, path, e) => {
        e.preventDefault();
        if (isInternal) {
            let newPath = path;
            navigate(newPath);
        } else {
            window.open(path);
        }
    };

    const purchase = (e) => {};

    return (
        <div className='App'>
            <div style={{ marginBottom: '100px' }}>
                <div className='vialImage'>
                    {vialInfo.vialImage !== '' ? (
                        vialInfo.emotionType === 'Photo' ? (
                            <img
                                style={{
                                    maskSize: `${vialMaskSize}px`,
                                    WebkitMaskSize: `${vialMaskSize}px`,
                                    width: `${vialMaskSize}px`,
                                }}
                                className='vialImage-image'
                                src={vialInfo.vialImage}
                            />
                        ) : vialInfo.emotionType === 'ID Card' ? (
                            <img
                                style={{
                                    maskSize: `${cardMaskSize}px`,
                                    WebkitMaskSize: `${cardMaskSize}px`,
                                    width: `${cardMaskSize}px`,
                                }}
                                className='cardimage-image'
                                src={vialInfo.vialImage}
                            />
                        ) : null
                    ) : null}
                    {vialInfo.images.length ? (
                        <SwipeableViews
                            style={{
                                marginTop: '20px',
                                minHeight: `100%`,
                            }}
                        >
                            {vialInfo.images.map((image, index) => {
                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                        key={index}
                                    >
                                        <img
                                            style={{
                                                width: `95%`,
                                                height: `100%`,
                                            }}
                                            src={image}
                                        />
                                    </div>
                                );
                            })}
                        </SwipeableViews>
                    ) : null}

                    {vialInfo.description === '' ? null : (
                        <div className='commentInputContainer'>
                            <textarea
                                readOnly
                                style={{ resize: 'none' }}
                                type='text'
                                contentEditable={false}
                                value={vialInfo.description}
                                className='commentInput'
                            />
                        </div>
                    )}

                    {vialInfo.customData.length ? (
                        <div className='vialInfo-content'>
                            <div className='vialInfo'>
                                <div className='vialInfo-label'>Ticket</div>
                                <div className='vialInfo-value'>
                                    {vialInfo.ticket}
                                </div>
                            </div>
                            <div className='vialInfo'>
                                <div className='vialInfo-label'>Type</div>
                                <div className='vialInfo-value'>
                                    {vialInfo.emotionType}
                                </div>
                            </div>
                            <div className='vialInfo'>
                                <div className='vialInfo-label'>Time</div>
                                <div className='vialInfo-value'>
                                    {vialInfo.time}
                                </div>
                            </div>
                            {vialInfo.videoUrl !== '' ? (
                                <div className='vialInfo'>
                                    <div className='vialInfo-label'>Link</div>
                                    <div
                                        onClick={(e) =>
                                            routeChange(
                                                false,
                                                vialInfo.videoUrl,
                                                e
                                            )
                                        }
                                        className='vialInfo-value'
                                    >
                                        {vialInfo.videoUrl}
                                    </div>
                                </div>
                            ) : null}
                            {vialInfo.emotionType === 'Photo' ? (
                                <>
                                    <div className='vialInfo'>
                                        <div className='vialInfo-label'>
                                            Label
                                        </div>
                                        <div className='vialInfo-value'>
                                            {vialInfo.label}
                                        </div>
                                    </div>
                                    <div className='vialInfo'>
                                        <div className='vialInfo-label'>
                                            Waves
                                        </div>
                                        <div className='waves'>
                                            <div
                                                style={{ paddingRight: '12px' }}
                                                className='emotion-wave-container'
                                            >
                                                <div>&alpha;</div>
                                                <div className='emotion-wave-value'>
                                                    {vialInfo.customData[0]}%
                                                </div>
                                            </div>
                                            <div
                                                style={{ paddingRight: '12px' }}
                                                className='emotion-wave-container'
                                            >
                                                <div>&beta;</div>
                                                <div className='emotion-wave-value'>
                                                    {vialInfo.customData[1]}%
                                                </div>
                                            </div>
                                            <div
                                                style={{ paddingRight: '12px' }}
                                                className='emotion-wave-container'
                                            >
                                                <div>&theta;</div>
                                                <div className='emotion-wave-value'>
                                                    {vialInfo.customData[2]}%
                                                </div>
                                            </div>
                                            <div className='emotion-wave-container'>
                                                <div>&gamma;</div>
                                                <div className='emotion-wave-value'>
                                                    {vialInfo.customData[3]}%
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    ) : null}
                </div>
                <div
                    style={{
                        width: 'calc(100% - 32px)',
                        margin: 'auto',
                        marginBottom: '40px',
                    }}
                >
                    <button
                        className='order-button'
                        style={{ backgroundColor: '#000', color: '#fff' }}
                        onClick={(e) =>
                            routeChange(
                                false,
                                'https://booking.naver.com/booking/12/bizes/727145',
                                e
                            )
                        }
                    >
                        RANDOM DIVERSITY
                    </button>
                </div>
                <div style={{ height: '40px' }}></div>
            </div>
        </div>
    );
}

export default ShareEmotion;
